import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { catchError, throwError } from 'rxjs'

export const globalErrorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router)
    const toastr = inject(ToastrService)

    return next(req).pipe(
        catchError((error: any) => {
            // Handle the error here
            console.error('HTTP error:', error.status, error.message)

            if (error instanceof HttpErrorResponse) {
                // if (error.status === 403) {
                //     // setTimeout(() => router.navigateByUrl('/forbidden'))
                //     // return throwError(() => error)
                //     toastr.error('You do not have permission to perform this action.', 'Access Denied', {
                //         timeOut: 5000,
                //     })
                // }

                if (error.error?.errors) {
                    const errorMessages = Object.values(error.error.errors).flat()

                    const formattedErrors = errorMessages.map((msg) => `<li>${msg}</li>`).join('')
                    toastr.error(`<ul>${formattedErrors}</ul>`, 'Validation Errors', {
                        enableHtml: true,
                        timeOut: 10000,
                        extendedTimeOut: 10000,
                    })
                } else if (error.error) {
                    const traceId = error.error.traceId ? `Trace ID: ${error.error.traceId}` : ''
                    const errorMessage = error.error?.detail ?? error.message ?? 'An error occurred'

                    let html = `<p class="mb-0">${errorMessage}</p>`
                    if (traceId && error.status >= 500) {
                        html += `
                        <p class="small mb-0 mt-1">Click here to copy the error for support:</p>
                        <p class="small mb-0 text-truncate">${traceId}</p>
                        `
                    }

                    const errorToast = toastr.error(html, undefined, {
                        enableHtml: true,
                        timeOut: 10000,
                        extendedTimeOut: 10000,
                    })

                    errorToast.onTap.subscribe(() => {
                        if (traceId) {
                            navigator.clipboard.writeText(traceId)
                            toastr.success('Trace ID copied to clipboard', 'Success', { timeOut: 3000 })
                        }
                    })
                } else {
                    if (error.status === 403) {
                        setTimeout(() => router.navigateByUrl('/forbidden'), 0)
                        // return throwError(() => error)
                        toastr.error('You do not have permission to perform this action.', 'Access Denied', {
                            timeOut: 5000,
                        })
                    } else {
                        setTimeout(() => router.navigateByUrl('/error'), 0)
                        toastr.error('An unknown error occurred', 'Error', {
                            enableHtml: true,
                            timeOut: 10000,
                            extendedTimeOut: 10000,
                        })
                    }
                }
            } else if (error instanceof Error) {
                toastr.error(error.message, 'Error', {
                    enableHtml: true,
                    timeOut: 10000,
                    extendedTimeOut: 10000,
                })
            }

            // Return the error WITHOUT rethrowing to prevent it from reaching the global error handler
            // This stops the infinite loop while still allowing components to handle the error via rxResource
            return throwError(() => error)
        })
    )
}
